import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    padding: '30px 10px 30px 10px',
  },
});

const InvoiceLineItems = ({classes, invoice}) => {
  //TODO: remove hack to convert Map to Array
  const lineItems = [];
  invoice.lineItems.forEach((lineItem, id) => {
    lineItems.push(Object.assign({}, {id}, lineItem));
  });

  return(
    <div className={classes.root}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableCell} padding="dense" variant="head">Description</TableCell>
            <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Quantity</TableCell>
            <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Unit Price</TableCell>
            <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lineItems.length !== 0 &&
            lineItems.map((lineItem) => {
              return (
                <TableRow
                  key={lineItem.id}
                  >
                  <TableCell
                    padding="dense"
                    variant="body"
                    style={{width: '80%'}}
                    >
                    {lineItem.description}
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    >
                    {lineItem.quantity}
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    >
                      ${lineItem.unitPrice.toFixed(2)}
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    >
                      ${lineItem.total.toFixed(2)}
                  </TableCell>
                </TableRow>
              );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default withStyles(styles)(InvoiceLineItems);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/Preview/InvoiceLineItems.jsx